import React from "react";
import ProductionEstimator from "./components/ProductionEstimator";

function App() {
  return (
    <div className="App">
      <header className="bg-gray-800 text-white p-4">
        <h1 className="text-3xl font-bold">Agave Production Estimator</h1>
        <p className="mt-2">Track and forecast agave production and distribution</p>
      </header>
      <main className="container mx-auto py-6 px-4">
        <ProductionEstimator />
      </main>
    </div>
  );
}

export default App;
